import { createFileRoute } from '@tanstack/react-router'

import { QueryTokenToLocalStorage } from '~/components/query-token-to-local-storage'

import { tokenToLsSchema } from './-schemas/token-to-ls-schema'

export const Route = createFileRoute('/_centered-layout/token-to-ls')({
  component: QueryTokenToLocalStorage,
  validateSearch: search => tokenToLsSchema.parse(search),
})
